export default __webpack_public_path__ + "static/media/regulamento-de-rh-mario-bezerra.5e9a9ba0.pdf";